import { VStack, Checkbox } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";
import { useEffect } from "react";

const IsReturnAndPaid = observer(({ showShipment = true }) => {
  const { pageStore } = useStores();

  const handleChange = (field) => (e) => {
    console.log(pageStore.selected_view)
    pageStore.updateSelectedView({
      ...pageStore.selected_view,
      [field]: e.target.checked,
    });
    console.log(pageStore.selected_view);
  };

  const handleChangeSelf = (field, value) => {
    console.log(pageStore.selected_view);
    pageStore.updateSelectedView({
      ...pageStore.selected_view,
      [field]: value,
    });
    console.log(pageStore.selected_view);
  };

  useEffect(() => {
    handleChangeSelf("isNotReturn", true);
  }, []);

  return (
    <VStack
      align="start"
      spacing={2}
      bg="#333"
      p={3}
      borderRadius="10px"
      width="250px"
      color="#EEEEEE"
    >
      <Checkbox
        colorScheme="green"
        isChecked={pageStore.selected_view?.isReturn == true || false}
        onChange={handleChange("isReturn")}
      >
        Возвратный счёт
      </Checkbox>

      <Checkbox
        colorScheme="green"
        isChecked={!!pageStore.selected_view?.isNotReturn}
        onChange={handleChange("isNotReturn")}
      >
        Обычный счёт
      </Checkbox>

      {showShipment && (
        <>
          <Checkbox
            colorScheme="green"
            isChecked={pageStore.selected_view?.isFullShipment || false}
            onChange={handleChange("isFullShipment")}
          >
            100% отгрузки
          </Checkbox>

          <Checkbox
            colorScheme="green"
            isChecked={pageStore.selected_view?.isPartialShipment || false}
            onChange={handleChange("isPartialShipment")}
          >
            Неполная отгрузка
          </Checkbox>
        </>
      )}
    </VStack>
  );
});

export default IsReturnAndPaid;